export default {
  success: "موفق",
  approved: "تایید",
  error: "ناموفق",
  warning: "توجه",
  holiday: "تعطیلی",
  info: "اطلاع",
  usernameOrPasswordIsWrong: "نام کاربری یا رمز عبور صحیح نمی‌باشد",
  errorOccurred: "خطایی رخ داده",
  successAction: ".با موفقیت انجام شد.",
  failedAction: ".انجام نشد! لطفا دوباره تلاش کنید.",
  submissionSucceed: "ثبت با موفقیت انجام شد.",
  submissionFailedT:"انتقال انجام نشد, بدلیل اینکه این بیمار در وقت جدید قبلا ثبت شده است.",
  submissionFailed: "ثبت با خطا مواجه شد.",
  editionFailed: "ویرایش با خطا مواجه شد.",
  editionSucceed: "ویرایش با موفقیت انجام شد.",
  deletionSucceed: "حذف با موفقیت انجام شد.",
  deletionRequestSucceed: "درخواست حذف با موفقیت ثبت شد.",
  deletionFailed: "حذف با  خطا مواجه شد.",
  duplicatedData: "برخی از اطلاعات تکراری است!",
  notFound: "صفحه یافت نشد!",
  badRequestTitle: "درخواست نامعتبر!",
  badRequest: "برخی از اطلاعات وارد نشده اند و یا نامعتبر هستند.",
  genderNotDetect: "جنسیت این شخص تعیین نشده است.",
  spouseNotRegistered: "اطلاعات همسر وارد نشده است!",
  userNotFound: "کاربری با این اطلاعات یافت نشد",
  clickForNewRegistration: "ثبت {user} جدید",
  amountIsMoreThanPayable: "مبلغ پرداختی از قابل پرداخت بیشتر است.",
  patientAge: "سن بیمار برای ایجاد پذیرش مجاز نیست",
  patientGender: "امکان پذیرش بیمار آقا وجود ندارد",
  patientMaritalStatus: "امکان پذیرش بیمار مجرد وجود ندارد",
  noMedicalRecord: "پرونده ای موجود نیست",
  notRealizationOfMarriage: "احراز زوجیت انجام نشده است!",
  nationCodeLengthError: "کد ملی وارد شده صحیح نمیباشد، لطفا آن را اصلاح کنید",
  todayVisitStatus:
    "قابلیت ویزیت مجدد وجود ندارد! بیمار امروز ویزیت شده است و شما می‌توانید در صورت لزوم ویزیت وی را ویرایش کنید!",
  sameServiceSameDr: "امکان ثبت مجدد خدمت با این پزشک وجود ندارد.",
  invalidDateInterval: "تاریخ پایان نباید قبل از تاریخ شروع باشد.",
  invalidDate: "تاریخ نامعتبر است و یا وارد نشده است.",
  areYouSureOfDeletion: "آیا از حذف {item} اطمینان دارید؟",
  fillInAtLeastOneField: "لطفا حداقل یک فیلد را پر کنید",
  noUserFoundForThisFile: "کاربری برای این پرونده وجود ندارد",
  medicalRecordNotFound: "پرونده پزشکی یافت نشد",
  isSingle: "مجرد است",
  marriageDateNotEntered: "تاریخ ازدواج ثبت نشده است",
  noReferenceReason: "دلیل ارجاعی وجود ندارد",
  fileNotSelected: "فایل انتخاب نشده است",
  selectAtLeastOneItem: " لطفا حداقل یک آیتم انتخاب کنید",
  dateNotSelected: "تاریخ انتخاب نشده است",
  noDataAvailable: "اطلاعاتی یافت نشد",
  sorryNoMatchingOptions: "گزینه ای یافت نشد",
  referencesAlert: "شما تعداد {count} مورد علت ارجاع خوانده نشده دارید",
  sendToQueueSucceed: "بیمار در صف پذیرش قرار گرفت",
  sendToCashierSucceed: "بیمار در کارتابل قرار گرفت",
  legalRejected:
    "وضعیت حقوقی متقاضی رد است.جهت اطلاع بیشتر به بخش توضیحات پرونده حقوقی مراجعه نمایید ",
  legalConditioned:
    "وضعیت حقوقی متقاضی مشروط است.جهت اطلاع بیشتر به بخش توضیحات پرونده حقوقی مراجعه نمایید ",
  legalRejectAndConditioned:
    "وضعیت حقوقی متقاضی مشروط/رد است.جهت اطلاع بیشتر به بخش توضیحات پرونده حقوقی مراجعه نمایید ",
  legalApproved:
    "وضعیت حقوقی متقاضی تایید شد و انجام خدمات پزشکی برای او بلامانع است. ",
  itemsRequired: "آیتم‌های زیر اجباری هستند: {items} ",
  oneItemRequired: "یکی از آیتم‌های زیر اجباری هستند: {items} ",
  successRecall: "درخواست فراخوانی با موفقیت ثبت شد.",
  successPresentRecall: "حضور دکتر با موفقیت ثبت شد.",
  successEndRecall: "پایان حضور با موفقیت انجام شد.",
  fillTheSpouseInfo: "جهت ثبت مراجعه ناباروری اطلاعات همسر را پر کنید",
  fileUploadFailed: "بارگذاری فایل با خطا مواجه شد",
  editUserInfoFromOldSystem:
    "لطفا اطلاعات بیمار مجددا بررسی گردد و نحوه‌ی آشنایی از سیستم قدیمی تغییر یابد.",
  selectDoctor: "لطفا پزشک را انتخاب کنید",
  timeNotSelected: "زمان انتخاب نشده است!",
  theTimelineIsIncorrect: "بازه زمانی صحیح نیست!",
  completeBlanks: "لطفا همه ی فیلدها را تکمیل کنید",
  isComeNotDelete: "امکان حذف رزرو در وضعیت مراجعه شده وجود ندارد",
  multipleOfFive: "بازه زمانی باید مضربی از ۵ باشد",
  changeLangToEn:"لطفا زبان کیبورد را انگلیسی کنید",
  ErrorMobile:"شماره موبایل به درستی وارد نشده است.",
  MandatoryUnit :"انتخاب واحدالزامی است!",
  Interval:" بازه زمانی باید مضربی از ۵ باشد ",
  ErrFromTime:'زمان شروع الزامی است!',
  ErrEndTime:'زمان پایان الزامی است!',
  ErrMaxTurn: 'تعداد بیمار در هر نوبت را وارد نمایید!',
  SearchError: 'لطفا حداقل یکی از فیلدها را پر کنید ',
  createPlan:"برنامه کاری پزشک ایجاد شد.",
  syncPlan:"برنامه کاری پزشک بروز رسانی شد",
  ErrorFind:"لطفا یکی از فیلدها را پر کنید.",
  ErrorFindCountry:"لطفا ملیت را انتخاب کنید",
  ErrFatherName:"نام پدر الزامی است.",
  DateAlready:"این تاریخ قبلا ثبت شده است.",
  ErrFirstName:"نام  الزامی است.",
  ErrLastName:"نام خانوادگی الزامی است.",
  ErrNationalCode:"کدملی الزامی است.",
  errMobile:"شماره موبایل الزامی است"


};
